import { createSlice } from '@reduxjs/toolkit';
export const initialState = {
    searchEventID: '',
    searchEventGoBackURL: ''
};
export const monitoringSearchEventSlice = createSlice({
    name: 'monitoringSearchEvent',
    initialState,
    reducers: {
        setSearchEventID: (state, action) => {
            state.searchEventID = action.payload;
        },
        setSearchEventGoBackURL: (state, action) => {
            state.searchEventGoBackURL = action.payload;
        },
        clearSearchEventState: () => initialState
    }
});
export const { setSearchEventID, setSearchEventGoBackURL, clearSearchEventState } = monitoringSearchEventSlice.actions;
export default monitoringSearchEventSlice.reducer;
